import { Injectable } from '@angular/core';
import * as polyline from '@mapbox/polyline';

declare var L: any;

const defaultCoords: number[] = [40, -80];
const defaultZoom: number = 8;
let map;

@Injectable()
export class RouteMapService {
  constructor() {}

  setMap() {
    map = L.map('map').setView(defaultCoords, defaultZoom);
    map.maxZoom = 100;
    L.tileLayer('https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);
  }

  clearMap(){
    map.remove();
    this.setMap();
  }

  plotGpx(file, color, callback) {    
    new L.GPX(file, { 
      async: true,
      polyline_options: {
        color: color ? color : 'rgb(0, 0, 0)',
        opacity: 0.95,
        weight: 2,
        lineCap: 'round'
      },
      marker_options: {
        startIconUrl: 'assets/pin-icon-start.png',
        endIconUrl: 'assets/pin-icon-end.png',
        shadowUrl: 'assets/pin-shadow.png'
      }
    })
      .on('loaded', function(e) {
        map.fitBounds(e.target.getBounds());                
        callback((e.target.get_distance() / 1000).toFixed(2), e.target.get_elevation_gain(), e.target.get_elevation_loss());
      })
      .addTo(map);
  }

  addPolyLine(pl, color){        
    var latlngs = polyline.decode(pl);
    var PolyLine = L.polyline(latlngs, {
      color: color ? color : 'rgb(0, 0, 0)',
      weight : 2,
      opacity: 0.95,
      lineCap :'round'
    }).addTo(map);
    map.fitBounds(PolyLine.getBounds());    
  }
}
